<template>
  <b-modal ok-only id="common-modal" :title="title">
    <p class="my-4 text-center">{{body}}</p>
  </b-modal>
</template>
<script>
export default {
  name: 'CommonModal',
  props: {
    'title': String,
    'body': String
  },
  methods: {
    msgBoxOk (msg) {
      this.$bvModal.msgBoxOk(msg, {
        title: '',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'primary',
        okTitle: '確認',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        //  align-items-start
        centered: true,
        dialogClass: 'align-items-start t-10r'
      }).then(value => {
        this.boxTwo = value
      }).catch(err => {
        console.log(err)
        // An error occurred
      })
    },
    msgBoxConfirm (msg, args = null) {
      this.$bvModal.msgBoxConfirm(msg, {
        title: '',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'OK',
        cancelTitle: 'キャンセル',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        hideHeaderClose: false,
        centered: true,
        dialogClass: 'align-items-start t-10r word-pre-wrap'
      }).then(isOk => {
        if (isOk) {
          if (args) {
            this.$emit('confirmOk', args)
          } else {
            this.$emit('confirmOk')
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    msgBoxYesNo (msg, args = null) {
      this.$bvModal.msgBoxConfirm(msg, {
        title: '',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'はい',
        cancelTitle: 'いいえ',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        hideHeaderClose: false,
        centered: true,
        dialogClass: 'align-items-start t-10r word-pre-wrap'
      }).then(isOk => {
        if (isOk) {
          if (args) {
            this.$emit('confirmYes', args)
          } else {
            this.$emit('confirmYes')
          }
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
<style>
.word-pre-wrap{
    white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/CommonModal.vue